// extracted by mini-css-extract-plugin
export default {"project":"studyWindow_project__Gf4Nh"};